import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hjælpekomponent der sikrer, at siden altid rulles op i toppen ved ruteskift.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // 'instant' sikrer, at der ikke er en glidende overgang, hvilket føles mere naturligt ved ruteskift
    });
  }, [pathname]);

  return null;
}
